var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3 14C3 12.8954 3.89543 12 5 12C6.10457 12 7 12.8954 7 14V19C7 20.1046 6.10457 21 5 21C3.89543 21 3 20.1046 3 19V14ZM17 10C17 8.89543 17.8954 8 19 8C20.1046 8 21 8.89543 21 10V19C21 20.1046 20.1046 21 19 21C17.8954 21 17 20.1046 17 19V10ZM10 4C10 2.89543 10.8954 2 12 2C13.1046 2 14 2.89543 14 4V19C14 20.1046 13.1046 21 12 21C10.8954 21 10 20.1046 10 19V4Z",
    fill: "#FDBF26"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame2);
export default __webpack_public_path__ + "static/media/Frame2.e08db62e4a5729f4c92e7be25e4c1b9b.svg";
export { ForwardRef as ReactComponent };